<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="text-light-gold text-uppercase mb-2">
          Primary Office Contact
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">First Name</label>
              <div class="input-group">
                <input
                  type="text"
                  name="first_name"
                  @change="form.errors.clear('first_name')"
                  :class="[
                    { 'is-invalid': form.errors.has('first_name') },
                    'form-control',
                  ]"
                  class="form-control w-100"
                  v-model="lead.first_name"
                  placeholder="First Name"
                />
                <div class="invalid-feedback">Please choose a first name.</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">Last Name</label>
              <div class="input-group">
                <input
                  type="text"
                  name="last_name"
                  @change="form.errors.clear('last_name')"
                  :class="[
                    { 'is-invalid': form.errors.has('last_name') },
                    'form-control',
                  ]"
                  class="form-control w-100"
                  v-model="lead.last_name"
                  placeholder="Last Name"
                />
                <div class="invalid-feedback">Please choose a last name.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-light-gold text-uppercase mb-2">Business Info</div>

        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">Office Email</label>
              <div class="input-group">
                <input
                  type="text"
                  name="email"
                  @change="form.errors.clear('email')"
                  :class="[
                    { 'is-invalid': form.errors.has('email') },
                    'form-control',
                  ]"
                  class="form-control w-100"
                  v-model="lead.email"
                  placeholder="Email"
                />
                <div class="invalid-feedback">Please choose a email.</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group">
              <label class="">Office Phone</label>
              <vue-tel-input
                inputId="phone"
                mode="international"
                :class="'w-100'"
                :onlyCountries="['AU', 'GB', 'NZ', 'US']"
                v-model="lead.phone"
              />
            </div>
          </div>
          <div class="col-12">
            <address-not-found
              @update="updateAddress"
              :layout="4"
              :data="{
                not_found: not_found,
                address: address,
              }"
            ></address-not-found>

            <div class="form-group" v-if="!not_found">
              <label class="">Office Address</label>
              <div>
                <google-maps-autocomplete
                  class="w-100"
                  :value="lead.address"
                  v-on:address-components="saveAddresses"
                  placeholder="10 Street Name"
                ></google-maps-autocomplete>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="lead.profile_type_id == 1">
          <div class="col-12 col-lg-6 mb-3">
            <div class="mb-2">
              Is
              <strong>{{ lead.name ? lead.name : "the business" }}</strong> a
              member of The Australian Livestock & Property Agents Association
            </div>
            <el-radio v-model="lead.is_alpa" :label="true">Yes</el-radio>
            <el-radio v-model="lead.is_alpa" :label="false">No</el-radio>
          </div>
          <div class="col-12 col-lg-6">
            <div class="mb-2">
              Is
              <strong>{{ lead.name ? lead.name : "the business" }}</strong>
              Autions Plus Accredited
            </div>
            <el-radio v-model="lead.is_action_plus_tpa" :label="true"
              >Yes</el-radio
            >
            <el-radio v-model="lead.is_action_plus_tpa" :label="false"
              >No</el-radio
            >
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div class="d-flex text-right justify-content-between">
        <el-button class="btn-secondary px-4" @click="updateLead('prev')">
          Back
        </el-button>
        <div>
          <el-button
            class="btn-secondary px-4"
            @click="updateLead('save')"
            v-if="onboardingAccount.is_completed == false"
          >
            Save Progress
          </el-button>
          <el-button class="btn-secondary" @click="updateLead('next')">
            Next
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputAbnLookup from "../../../../common/InputAbnLookup.vue";
import InputBusinessNameLookup from "../../../../common/InputBusinessNameLookup.vue";
import AddressNotFound from "../../../../common/AddressNotFound.vue";
import AbnLookup from "../../../../frontend/modelsPortal/common/AbnLookup";
import Form from "form-backend-validation";
export default {
  components: {
    InputAbnLookup,
    InputBusinessNameLookup,
    AddressNotFound,
  },
  props: {
    initial_lead: {
      type: Object,
    },
    businessTypes: {
      type: Array,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  data() {
    return {
      lead: { ...this.initial_lead },
      form: new Form(),
      not_found: false,
      address: {},
      loading: false,
    };
  },
  methods: {
    returnList(data) {
      this.businessList = data;
      this.showButtons = false;
    },
    updateLead(action) {
      if (this.not_found) {
        this.lead.extra_attributes = { address: this.address };
      }
      this.$emit("update-lead", this.lead, action);
    },

    updateAddress(data) {
      this.not_found = data.not_found;
      this.address = data.address;
    },
    saveAddresses: function (address) {
      this.lead.extra_attributes = { address: address };
      this.lead.extra_attributes.address["unit_number"] = null;
    },
  },
};
</script>
